import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useSettings } from '../context/SettingsContext';

function MetaTags({ title, description }) {
  const { settings } = useSettings();
  
  const siteName = settings?.siteName || 'Kentech Phones';
  const siteDescription = description || 'Professional device repair services for phones, tablets, watches, consoles, and laptops. Quick, reliable, and affordable repairs.';
  const pageTitle = title ? `${title} | ${siteName}` : siteName;
  
  // Convert relative logo URL to absolute URL for meta tags
  const logoUrl = settings?.logo ? 
    (settings.logo.startsWith('http') ? settings.logo : `${window.location.origin}${settings.logo}`) : 
    `${window.location.origin}/favicon.ico`;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={siteDescription} />
      
      {/* Open Graph tags */}
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={siteDescription} />
      <meta property="og:image" content={logoUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={siteName} />
      
      {/* Twitter Card tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={siteDescription} />
      <meta name="twitter:image" content={logoUrl} />
      
      {/* Favicon */}
      {settings?.logo && (
        <>
          <link rel="icon" href={settings.logo} />
          <link rel="apple-touch-icon" href={settings.logo} />
        </>
      )}
    </Helmet>
  );
}

export default MetaTags;